var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      ref: "root",
      staticClass: "sect",
      attrs: {
        id: _setup.anchor(_setup.props.name),
        "data-name": _setup.props.name,
      },
    },
    [
      _vm._t("default", function () {
        return [_vm._v("OPart " + _vm._s(_setup.props.name))]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }